// Third party components
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// MUI components
import {Card, CardContent, Container, Grid, Stack, Typography} from '@mui/material';

// Shared Components
import { Button, LineLoader, LoadingSpinner, SubHeader} from '@timmons-group/shared-react-components';

// Own components
import ActivityDetails from '../features/Activity/ActivityDetails';

// Hooks
import { useActivity, ACTIONS } from '../hooks/useActivity';

const ViewActivity = () => {
  let { id } = useParams();
  const bigStore = useActivity();
  const { activityState, unmount, dispatch } = bigStore;
  const { activity, modifying, loading } = activityState;

  // This effect will also fire if the id changes in the url
  useEffect(() => {
    if(id) {
      dispatch({type: ACTIONS.SET_ID, payload: id});
    }

    // Unmount on cleanup to reset the state
    return () => {
      unmount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return (
      <Container>
        <Card>
          <CardContent>
            <LineLoader message="Loading..." color="secondary" />
          </CardContent>
        </Card>
      </Container>
    );
  }
  else if (!loading && (!activity || activityState?.error)) {
    return (
      <Container>
        <Card>
          <CardContent>
            <Typography sx={{textAlign: 'center'}} variant="panelHeader">{activityState?.error?.response?.data?.error || 'Activity not found'}</Typography>
          </CardContent>
        </Card>
      </Container>
    );
  }

  return (
    <>
      <SubHeader
        title={ activity.activityName }
        sx={{ fontSize: '1.25 rem'}}
        rightRender={
          () =>
            <Stack spacing={2} direction="row" justifyContent="flex-end">
              <Button color="secondary" target="_blank" href={activity.survey123Url} label="Edit in Survey123" />
            </Stack>
        }
      />
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <ActivityDetails activity={activity} />
        </Grid>
      </Grid>
      <LoadingSpinner isActive={modifying} />
    </>
  );
};

export default ViewActivity;
